/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_account_renew_password_errors_400 = /** @type {(inputs: {}) => string} */ () => {
	return `Odkaz na obnovení hesla je neplatný nebo vypršel.`
};

const da_account_renew_password_errors_400 = /** @type {(inputs: {}) => string} */ () => {
	return `Linket til nulstilling af adgangskode er ugyldigt eller udløbet.`
};

const de_account_renew_password_errors_400 = /** @type {(inputs: {}) => string} */ () => {
	return `Der Link zum Zurücksetzen des Passworts ist ungültig oder abgelaufen.`
};

const en_account_renew_password_errors_400 = /** @type {(inputs: {}) => string} */ () => {
	return `The password reset link is invalid or has expired.`
};

const es_account_renew_password_errors_400 = /** @type {(inputs: {}) => string} */ () => {
	return `El enlace de restablecimiento de contraseña no es válido o ha expirado.`
};

const fr_account_renew_password_errors_400 = /** @type {(inputs: {}) => string} */ () => {
	return `Le lien de réinitialisation du mot de passe est invalide ou a expiré.`
};

const hu_account_renew_password_errors_400 = /** @type {(inputs: {}) => string} */ () => {
	return `A jelszó-visszaállítási link érvénytelen vagy lejárt.`
};

const it_account_renew_password_errors_400 = /** @type {(inputs: {}) => string} */ () => {
	return `Il link per reimpostare la password non è valido o è scaduto.`
};

const nl_account_renew_password_errors_400 = /** @type {(inputs: {}) => string} */ () => {
	return `De link om het wachtwoord te resetten is ongeldig of verlopen.`
};

const pl_account_renew_password_errors_400 = /** @type {(inputs: {}) => string} */ () => {
	return `Link do resetowania hasła jest nieprawidłowy lub wygasł.`
};

const pt_account_renew_password_errors_400 = /** @type {(inputs: {}) => string} */ () => {
	return `O link de redefinição de senha é inválido ou expirou.`
};

const sv_account_renew_password_errors_400 = /** @type {(inputs: {}) => string} */ () => {
	return `Länken för att återställa lösenordet är ogiltig eller har gått ut.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const account_renew_password_errors_400 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.account_renew_password_errors_400(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("account_renew_password_errors_400", locale)
	if (locale === "cs") return cs_account_renew_password_errors_400(inputs)
	if (locale === "da") return da_account_renew_password_errors_400(inputs)
	if (locale === "de") return de_account_renew_password_errors_400(inputs)
	if (locale === "en") return en_account_renew_password_errors_400(inputs)
	if (locale === "es") return es_account_renew_password_errors_400(inputs)
	if (locale === "fr") return fr_account_renew_password_errors_400(inputs)
	if (locale === "hu") return hu_account_renew_password_errors_400(inputs)
	if (locale === "it") return it_account_renew_password_errors_400(inputs)
	if (locale === "nl") return nl_account_renew_password_errors_400(inputs)
	if (locale === "pl") return pl_account_renew_password_errors_400(inputs)
	if (locale === "pt") return pt_account_renew_password_errors_400(inputs)
	return sv_account_renew_password_errors_400(inputs)
};
export { account_renew_password_errors_400 as "account.renew_password_errors.400" }